module.exports = __webpack_public_path__ + "img/20190703154041YY截图20190703002929.e48ff3b8.png";